const SLIP_PUBLIC_URL = 'https://jne-cilacap.com/slip/public';
const SLIP_IMAGES_URL = 'https://jne-cilacap.com/slip/images';

export const resolveSlipMediaUrl = value => {
  const raw = String(value || '').trim();
  if (!raw) return '';
  if (/^(data:|blob:)/i.test(raw)) return raw;
  if (/^\/?images\//i.test(raw)) {
    return `${SLIP_IMAGES_URL}/${raw.replace(/^\//, '')}`;
  }

  try {
    const parsed = new URL(raw, `${SLIP_PUBLIC_URL}/`);
    if (parsed.hostname === 'jne-cilacap.com' && parsed.pathname.startsWith('/storage/')) {
      return `${SLIP_PUBLIC_URL}${parsed.pathname}${parsed.search}`;
    }
    return parsed.href;
  } catch {
    const path = raw.replace(/^\.?\//, '').replace(/^public\//, '');
    return `${SLIP_PUBLIC_URL}/${path}`;
  }
};
